export default [
  {
    text: 'Предоставляется',
    value: true,
  },
  {
    text: 'Не предоставляется',
    value: false,
  },
];
